import { createReducer } from 'typesafe-actions'
import { GetGeneralSettingsResponseDto } from '@sparling/financial-common'
import { ActionTypes } from '../types'
import { LoadingStateEnum } from '../../types'
import { getGeneralSettingsRequest, getGeneralSettingsSuccess, getGeneralSettingsFailure } from '../actions'

export type GeneralSettingsState = {
  loading: LoadingStateEnum
  data: GetGeneralSettingsResponseDto | null
  error: Error | null
}

export const initialState = {
  loading: LoadingStateEnum.IDLE,
  data: null,
  error: null,
}

export const generalSettings = createReducer<GeneralSettingsState, ActionTypes>(initialState)
  .handleAction(getGeneralSettingsRequest, (state) => ({
    ...state,
    loading: LoadingStateEnum.LOADING,
  }))
  .handleAction(getGeneralSettingsSuccess, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.SUCCESS,
    data: payload,
  }))
  .handleAction(getGeneralSettingsFailure, (state, { payload }) => ({
    ...state,
    loading: LoadingStateEnum.ERROR,
    error: payload,
  }))
